import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

import { env as serverEnv } from '@poseidon/server/env';

export const env = createEnv({
  extends: [serverEnv],

  /**
   * Specify your client-side environment variables schema here. This way you can ensure the app
   * isn't built with invalid env vars. To expose them to the client, prefix them with
   * `NEXT_PUBLIC_`.
   */
  client: {
    NEXT_PUBLIC_FIREBASE_API_KEY: z.string().min(1),
    NEXT_PUBLIC_FIREBASE_APP_ID: z.string().min(1),
    // Fingerprint (required)
    NEXT_PUBLIC_FINGERPRINT_API_KEY: z.string().min(1),
    // other (Required)
    NEXT_PUBLIC_EXTENSION_URL: z.string().min(1),
    NEXT_PUBLIC_IMAGE_RESIZING_SERVER_URL: z.string().min(1),

    // for Development (Optional)
    NEXT_PUBLIC_DISABLE_REFETCH_ON_WINDOW_FOCUS: z
      .string()
      .optional()
      .transform((s) => {
        if (s == null) return false;
        return s === 'true';
      }),

    NEXT_PUBLIC_GMAIL_CLIENT_ID: z.string().min(1),

    // Optional

    // other (Optional)
    NEXT_PUBLIC_LOOM_APP_ID: z
      .string()
      .optional()
      .transform((s) => (s?.startsWith('BAKED_') ? undefined : s)),
    NEXT_PUBLIC_GTM: z
      .string()
      .optional()
      .transform((s) => (s?.startsWith('BAKED_') ? undefined : s)),
  },

  /**
   * You can't destruct `process.env` as a regular object in the Next.js edge runtimes (e.g.
   * middlewares) or client-side so we need to destruct manually.
   *
   * because NEXT_PUBLIC vars are inlined and we need them to be injectable
   * doing some hackery with string replacing anything that starts with a key
   * on start, see: replace-variables.sh
   *
   * https://phase.dev/blog/nextjs-public-runtime-variables/
   */
  runtimeEnv: {
    NEXT_PUBLIC_GMAIL_CLIENT_ID: process.env.NEXT_PUBLIC_GMAIL_CLIENT_ID,

    NEXT_PUBLIC_FIREBASE_API_KEY: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    NEXT_PUBLIC_FIREBASE_APP_ID: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    // Fingerprint (required)
    NEXT_PUBLIC_FINGERPRINT_API_KEY: process.env.NEXT_PUBLIC_FINGERPRINT_API_KEY,
    // other (Required)
    NEXT_PUBLIC_EXTENSION_URL: process.env.NEXT_PUBLIC_EXTENSION_URL,
    NEXT_PUBLIC_IMAGE_RESIZING_SERVER_URL: process.env.NEXT_PUBLIC_IMAGE_RESIZING_SERVER_URL,

    // Optional

    // Optional ONLY in DEV, don't care about string replacing
    NEXT_PUBLIC_DISABLE_REFETCH_ON_WINDOW_FOCUS: process.env.NEXT_PUBLIC_DISABLE_REFETCH_ON_WINDOW_FOCUS,

    // other (Optional)
    NEXT_PUBLIC_LOOM_APP_ID: process.env.NEXT_PUBLIC_LOOM_APP_ID,
    NEXT_PUBLIC_GTM: process.env.NEXT_PUBLIC_GTM,
  },

  /**
   * Run `build` or `dev` with `SKIP_ENV_VALIDATION` to skip env validation.
   * This is especially useful for Docker builds.
   */
  // skipValidation: !!process.env.SKIP_ENV_VALIDATION,

  /**
   * Makes it so that empty strings are treated as undefined.
   * `SOME_VAR: z.string()` and `SOME_VAR=''` will throw an error.
   */
  emptyStringAsUndefined: true,
});
